// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blogSingle__breadcrumbs{margin-bottom:3rem}.blogSingle__header{margin:0 auto;max-width:1016px;padding:0 2rem}.blogSingle__tableOfContents{margin:0 auto 5rem;max-width:90rem}@media(max-width:600px){.blogSingle__tableOfContents{margin:0 auto 4rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
